import {Controller} from '@hotwired/stimulus';
import Steppp from '@ramseyinhouse/steppp';

export default class extends Controller {
  static targets = ['step', 'stepCount', 'progress', 'next', 'submit', 'choice', 'resultText'];
  static values = { source: String, swap: String };

  initialize() {
    Steppp(this.element);
  }

  next() {
    if (this.stepCountTarget.textContent == this.stepTargets.length) return;

    this.stepCountTarget.textContent++;
    this.progressTarget.style.width = this.calculateWidth();

    if (this.stepCountTarget.textContent == this.stepTargets.length) {
      this.nextTarget.classList.add('!hidden');
      this.submitTarget.classList.remove('!hidden');
    }
    this.nextTarget.disabled = true;
    this.submitTarget.disabled = true;
  }

  enable() {
    this.nextTarget.disabled = false;
    this.submitTarget.disabled = false;
  }

  calculateWidth() {
    return `${Math.floor((this.stepCountTarget.textContent / this.stepTargets.length) * 100)}%`;
  }

  submit() {
    const results = {};
    this.submitTarget.disabled = true;
    this.submitTarget.classList.add('!hidden');
    this.choiceTargets.map((choice) => {
      if (choice.checked) results[choice.name] = choice.value
    });
    this.resultTextTarget.textContent = this.buildResultText(results);
    const source = this.hasSourceValue ? `source=${this.sourceValue}&` : '';
    const swap = this.hasSwapValue ? `swap=${this.swapValue}&` : '';

    window.location.href = `/coaching/one-on-one/results?${source}${swap}${new URLSearchParams(results).toString()}`;
  }

  buildResultText({ style }) {
    const stylePart = style !== 'i-m-not-sure' ? `${style} ` : ' ';
    return `Finding great ${stylePart}coaches for you...`;
  }
}
